import { groupIemStatusMap } from '@data/statuses';
import {
    ArrowDropDownRounded,
    CheckRounded,
    PlaylistRemoveRounded,
} from '@mui/icons-material';
import { Chip, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { get } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const GroupStatusField = ({ row, field, updateStatus, removeItem }) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);

    const fieldValue = get(row, field, 0);
    const status = groupIemStatusMap[fieldValue];

    return (
        <>
            <Chip
                variant="tonal"
                label={t(status.label)}
                color={status.color}
                deleteIcon={<ArrowDropDownRounded />}
                onDelete={e => setAnchorEl(e.currentTarget.parentElement)}
                onClick={e => {
                    e.stopPropagation();
                    setAnchorEl(e.currentTarget);
                }}
                size="small"
            />
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                onClick={e => e.stopPropagation()}
                MenuListProps={{ dense: true }}
            >
                {Object.entries(groupIemStatusMap).map(([key, value]) => (
                    <MenuItem
                        key={key}
                        onClick={() => {
                            updateStatus({
                                contactId: row.contact_id,
                                status: key,
                            });
                            setAnchorEl(null);
                        }}
                    >
                        <ListItemIcon>
                            {fieldValue.toString() === key && <CheckRounded />}
                        </ListItemIcon>
                        {t(value.label)}
                    </MenuItem>
                ))}
                <MenuItem
                    onClick={() => {
                        removeItem(row.contact_id);
                        setAnchorEl(null);
                    }}
                >
                    <ListItemIcon>
                        <PlaylistRemoveRounded fontSize="small" />
                    </ListItemIcon>
                    {t('Remove')}
                </MenuItem>
            </Menu>
        </>
    );
};
